import { Environment } from './types';

export const isDev = () =>
  import.meta.env.VITE_ENVIRONMENT === Environment.DEV;

export const isStag = () =>
  import.meta.env.VITE_ENVIRONMENT === Environment.STAG;

export const isProd = () =>
  import.meta.env.VITE_ENVIRONMENT === Environment.PROD;
